// AUTO-GENERATED by scripts/sync-locale-twins.mjs; do not edit.
// Source: a scan of literal src/app/hi/** page.tsx routes.
//
// HI_LITERAL_PATHS: every literal Hindi route (slug form, no /hi/ prefix) —
// lets the LanguageToggle switch to the EXACT nested twin when it exists.
// HI_TOP_LEVEL_SLUGS: Hindi slugs with a top-level page (hub fallback target).
// The en<->hi slug ALIASES stay hand-authored in locales.ts (they are naming
// decisions, not derivable); everything else about "does a twin exist" is
// derived from the filesystem so it can never drift again.

export const HI_LITERAL_PATHS: ReadonlySet<string> = new Set([
  "aaj-ka-rashifal",
  "amavasya",
  "ascendant-calculator",
  "ashtakvarga",
  "astrologers",
  "baby-names",
  "bhagyank-calculator",
  "birth-time-rectification",
  "calendar/festival",
  "career-ke-liye-jyotish",
  "career-report",
  "char-dasha",
  "choghadiya",
  "compatibility",
  "dasamsa",
  "dasha-calculator",
  "dosha-remedy-plan",
  "dosha-report",
  "dwadasamsa",
  "ekadashi",
  "free-kundali",
  "gemstones",
  "graha",
  "gun-milan",
  "jyotishi-se-baat-karen",
  "jyotishi-se-chat",
  "kaal-sarp-dosha",
  "kp-astrology",
  "kundli-matching",
  "lal-kitab-kundli",
  "mangal-dosha-calculator",
  "manglik-calculator",
  "mantras",
  "marriage-report",
  "masik-shivratri",
  "mercury-retrograde",
  "muft-jyotish-chat",
  "muhurat",
  "mulank-calculator",
  "nadi-astrology",
  "nakshatra",
  "nakshatra-calculator",
  "name-numerology",
  "navamsa-chart",
  "numerology",
  "panchang",
  "pandits",
  "pitra-dosha",
  "pradosh",
  "prashna-kundali",
  "privacy",
  "purnima",
  "rahu-kaal",
  "rashi",
  "rashi-calculator",
  "remedies",
  "sade-sati",
  "sankashti-chaturthi",
  "sankranti",
  "saptamsa",
  "saturn-transit",
  "shaadi-ke-liye-jyotish",
  "shadbala",
  "shashtiamsa",
  "shubh-muhurat",
  "shubh-muhurat/today",
  "tara-balam",
  "tithi-today",
  "transits",
  "trimsamsa",
  "upay",
  "vastu-shastra",
  "venus-transit",
  "vrat-calendar",
  "widgets",
  "yogini-dasha",
]);

export const HI_TOP_LEVEL_SLUGS: ReadonlySet<string> = new Set([
  "aaj-ka-rashifal",
  "amavasya",
  "ascendant-calculator",
  "ashtakvarga",
  "astrologers",
  "baby-names",
  "bhagyank-calculator",
  "birth-time-rectification",
  "career-ke-liye-jyotish",
  "career-report",
  "char-dasha",
  "choghadiya",
  "compatibility",
  "dasamsa",
  "dasha-calculator",
  "dosha-remedy-plan",
  "dosha-report",
  "dwadasamsa",
  "ekadashi",
  "free-kundali",
  "gemstones",
  "graha",
  "gun-milan",
  "jyotishi-se-baat-karen",
  "jyotishi-se-chat",
  "kaal-sarp-dosha",
  "kp-astrology",
  "kundli-matching",
  "lal-kitab-kundli",
  "mangal-dosha-calculator",
  "manglik-calculator",
  "mantras",
  "marriage-report",
  "masik-shivratri",
  "mercury-retrograde",
  "muft-jyotish-chat",
  "muhurat",
  "mulank-calculator",
  "nadi-astrology",
  "nakshatra",
  "nakshatra-calculator",
  "name-numerology",
  "navamsa-chart",
  "numerology",
  "panchang",
  "pandits",
  "pitra-dosha",
  "pradosh",
  "prashna-kundali",
  "privacy",
  "purnima",
  "rahu-kaal",
  "rashi",
  "rashi-calculator",
  "remedies",
  "sade-sati",
  "sankashti-chaturthi",
  "sankranti",
  "saptamsa",
  "saturn-transit",
  "shaadi-ke-liye-jyotish",
  "shadbala",
  "shashtiamsa",
  "shubh-muhurat",
  "tara-balam",
  "tithi-today",
  "transits",
  "trimsamsa",
  "upay",
  "vastu-shastra",
  "venus-transit",
  "vrat-calendar",
  "widgets",
  "yogini-dasha",
]);
